import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  CompositionTypeBean,
  CompositionTypeSearchCriteria,
  RestCompositionTypeListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import {
  CancelIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class CompositionTypeListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {}
  componentDidUpdate() {
    this.setInputFocus();
    //
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  editCompositionTypeSearch = (e, val, rowdata) => {
    if (e.detail === 1) this.props.editCompositionTypeSearch(val, rowdata);
  };
  deleteComposition = (e, rowData) => {
    if (e.detail === 1) this.props.deleteComposition(rowData);
  };

  buttonCancelClickCallback = (e) => {
    if (e.detail === 1) this.props.buttonCancelClickCallback();
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms(e);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let compositionType_list = this.props.compositionType_list;
    let compositionTypeData = this.props.compositionTypeData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">CompositionType</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="text"
                name="code"
                onChange={this.props.onChange}
                value={compositionTypeData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                ref={this.listFormCodeRef}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {compositionType_list != null ? (
              <tbody>
                {compositionType_list.map((Info, index) => (
                  <tr key={index} data-item={Info}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editCompositionTypeSearch(e, Info.code, Info)
                        }
                      >
                        {Info.code}
                      </Button>
                    </td>
                    <td> {Info.description}</td>
                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    {/* {Info.isApplied == false ? (
                      <td className="text-right">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) => this.deleteComposition(e, Info.code)}
                        >
                          {<DeleteIcon />}
                        </Button>
                      </td>
                    ) : (
                      <Button
                        variant="secondry"
                        onClick={(e) => this.buttonCancelClickCallback(e)}
                      >
                        <CancelIcon />
                      </Button>
                    )} */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {compositionType_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class CompositionTypeEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
    this.state = {
      showHide: this.props.showHide,
      compositionTypeData: this.props.compositionTypeData,
    };
  }
  componentDidMount() {
    this.setInputFocus();
  }
  componentDidUpdate() {
    //
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  saveCompositionType = (e) => {
    this.props.saveCompositionType(this.state.compositionTypeData);
  };
  closeCompositionTypeEntryForm() {
    this.props.closeCompositionTypeEntryForm();
  }
  render() {
    let compositionTypeData = this.props.compositionTypeData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={compositionTypeData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter CompositionTypeCode"
              onChange={this.onChange}
              value={compositionTypeData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={compositionTypeData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={compositionTypeData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}
class CompositionTypeList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      compositionType_list: [],
      response: {},
      pageTitle: "Composition Type",
      compositionTypeData: new CompositionTypeBean(),
      pageList: new PageListBean(),
      criteria: new CompositionTypeSearchCriteria(),
      companyCode: "",
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isCompositionTypeListFormOpen: true,
      isCompositionTypeEntryFormOpen: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage(1);
    this.cleardata();
  }
  moduleCaption = "Composition Type";
  cleardata = () => {
    let compositionTypeData = new CompositionTypeBean();
    compositionTypeData.companyCode = this.companyCode;
    this.setState({ compositionTypeData: compositionTypeData });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  saveCompositionTypeResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeCompositionTypeEntryForm();
    } else {
      this.handleresponse(response.data);
    }
  };
  saveCompositionType = (compositionTypeData) => {
    if (compositionTypeData.isFetched == true) {
      if (SecurityAccessManager.CompositionTypeMaintenanceEdit_IsAccessible()) {
        MasterService.updateCompositionType(
          compositionTypeData,
          this.saveCompositionTypeResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Edit Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.CompositionTypeMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createCompositionType(
          compositionTypeData,
          this.saveCompositionTypeResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Create Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  editCompositionTypeResponse = (response) => {
    if (response.data != null) {
      if (response.data.compositionTypeBean != null) {
        let compositionTypeData = response.data.compositionTypeBean;
        this.setState({
          compositionTypeData: compositionTypeData,
        });
        this.disable();
      }
    }
    this.openCompositionTypeEntryForm();
  };

  editCompositionTypeSearch = (compositionTypeCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = compositionTypeCode;
    if (SecurityAccessManager.CompositionTypeMaintenanceView_IsAccessible()) {
      MasterService.readCompositionType(
        readrestInput,
        this.editCompositionTypeResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let temp_compositionTypedata = this.state.compositionTypeData;
    temp_compositionTypedata[e.target.name] = e.target.value;
    this.setState({
      compositionTypeData: temp_compositionTypedata,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let compositionTypeData = this.state.compositionTypeData;
    compositionTypeData.companyCode = this.companyCode;
    compositionTypeData.code =
      this.state.compositionTypeData.code.toUpperCase();
    this.clearError();
    this.saveCompositionType(compositionTypeData);
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeCompositionTypeEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openCompositionTypeEntryForm = () => {
    this.setState({
      isCompositionTypeListFormOpen: false,
      isCompositionTypeEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };
  closeCompositionTypeEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isCompositionTypeListFormOpen: true,
      isCompositionTypeEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,

      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isDisableFields: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
    this.loadPage(1);
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  loadCompositionTypeResponse = (response) => {
    if (
      response.data != null &&
      response.data.compositionTypePageList != null
    ) {
      let compositionTypeList = new Array();
      if (
        !isEmptyArray(response.data.compositionTypePageList.compositionTypes)
      ) {
        compositionTypeList =
          response.data.compositionTypePageList.compositionTypes;
        compositionTypeList.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage = response.data.compositionTypePageList.currentPage;
      pageList.pageSize = response.data.compositionTypePageList.pageSize;
      pageList.totalCount = response.data.compositionTypePageList.totalCount;
      this.setState({
        compositionType_list: compositionTypeList,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = new CompositionTypeSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadCompositionTypePage(pageInput, criteria);
  };
  loadCompositionTypePage = (pageList, searchCriteria) => {
    let criteria = new CompositionTypeSearchCriteria();
    criteria = searchCriteria;

    let requestInput = new RestCompositionTypeListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.CompositionTypeMaintenanceView_IsAccessible()) {
      MasterService.getCompositionTypePageList(
        requestInput,
        this.loadCompositionTypeResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  buttonCancelClickCallback = () => {
    let empArray = [];
    let errorMessage = "Access Denied";
    empArray.push(errorMessage);
    this.setState({
      alertMessage: empArray,
      alertType: "danger",
      isShowAlert: true,
    });
  };
  deleteComposition = (rowData) => {
    let criteria = new CompositionTypeSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.code = rowData;
    if (SecurityAccessManager.CompositionTypeMaintenanceDelete_IsAccessible()) {
      MasterService.deleteCompositionType(
        criteria,
        this.deleteCompositionTypeResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Delete Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteCompositionTypeResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  opentypeforms = () => {
    let compositionTypeData = this.state.compositionTypeData;
    this.editCompositionTypeSearch(compositionTypeData.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.compositionType_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ compositionType_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isCompositionTypeListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isCompositionTypeListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isCompositionTypeListFormOpen && (
          <CompositionTypeListForm
            compositionType_list={this.state.compositionType_list}
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            opentypeforms={this.opentypeforms}
            compositionTypeData={this.state.compositionTypeData}
            editCompositionTypeSearch={this.editCompositionTypeSearch}
            saveCompositionType={this.save}
            deleteComposition={this.deleteComposition}
            buttonCancelClickCallback={this.buttonCancelClickCallback}
            onChange={this.onChange}
            enterKeyEventHandler={this.enterKeyEventHandler}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {!this.state.isCompositionTypeListFormOpen && (
          <CompositionTypeEntryForm
            compositionTypeData={this.state.compositionTypeData}
            closeCompositionTypeEntryForm={this.closeCompositionTypeEntryForm}
            saveCompositionType={this.saveCompositionType}
            editCompositionType={this.editCompositionType}
            onChange={this.onChange}
            isDisableFields={this.state.isDisableFields}
          />
        )}
      </div>
    );
  }
}
function CompositionTypeAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <CompositionTypeList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default CompositionTypeAttributeModule;
